export default function initVote() {
  const up = document.querySelector('.vote-btn.up');
  const down = document.querySelector('.vote-btn.down');
  const scoreEl = document.querySelector('.vote-score .num');
  if (!up || !down || !scoreEl) return;

  const basePercent = parseInt(scoreEl.dataset.basePercent || '96', 10);
  let my = null;

  const render = () => {
    let displayPercent = basePercent;
    if (my === 'up') {
      displayPercent = Math.min(100, basePercent + 1);
    } else if (my === 'down') {
      displayPercent = Math.max(0, basePercent - 1);
    }
    scoreEl.textContent = displayPercent + '%';
    up.classList.toggle('is-on', my === 'up');
    down.classList.toggle('is-on', my === 'down');
  };

  up.addEventListener('click', () => {
    if (my === 'up') { my = null; }
    else { my = 'up'; }
    render();
  });

  down.addEventListener('click', () => {
    if (my === 'down') { my = null; }
    else { my = 'down'; }
    render();
  });

  render();
}
